<template>
  <v-dialog v-model="dialog2" persistent max-width="400px">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip
        v-if="!isProductPage"
        bottom
        :color="$vuetify.theme.themes.light.tooltipColor"
      >
        <template v-slot:activator="{ on: tooltip, attrs }">
          <v-icon
            class="mr-3 vuetify-icon"
            color="#344452"
            v-bind="attrs"
            v-on="{ ...tooltip, ...dialog }"
            >mdi-file-download</v-icon
          >
        </template>
        <span>Download Documents</span>
      </v-tooltip>
      <span class="general-title" v-if="isProductPage" v-on="{ ...dialog }">
        DOWNLOAD DOCUMENTS
        <v-icon color="#344452" class="pb-2">mdi-file-download</v-icon>
      </span>
    </template>
    <div class="download-bx">
      <v-card class="dialog-cls mx-auto" tile>
        <v-card-title class="header-title">
          DOWNLOAD DOCUMENTS
          <v-spacer></v-spacer>
          <v-icon color="white" class="vuetify-icon" @click="dialog2 = false"
            >close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="dialog-text">
          <v-list rounded>
            <v-list-item-group color="primary">
              <v-list-item v-for="(document, i) in documents" :key="i">
                <v-list-item-content>
                  <v-list-item-title
                    class="dialog-title-sm"
                    v-text="document.name"
                  ></v-list-item-title>
                </v-list-item-content>
                <v-list-item-avatar>
                  <v-tooltip
                    bottom
                    :color="$vuetify.theme.themes.light.tooltipColor"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <a
                        ref="documents"
                        :href="document.url"
                        download
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon class="vuetify-icon">mdi-download</v-icon>
                      </a>
                    </template>
                    <span>Click here to download</span>
                  </v-tooltip>
                </v-list-item-avatar>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <a v-if="documents.length > 1">
            <v-card-title
              :class="
                $vuetify.breakpoint.mdAndUp
                  ? 'newsfeed-header-title px-0 justify-end'
                  : 'newsfeed-header-title px-0'
              "
            >
              <div class="download-all" @click="downloadAll">
                Download All
              </div>
            </v-card-title>
          </a>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import { saveAs } from "file-saver";

export default {
  name: "Documents",
  props: {
    documents: Array,
    newsFeedData: Object,
    product: Object
  },
  data() {
    return {
      dialog2: false,
      isProductPage: ""
    };
  },
  created() {
    this.isProductPage = this.$route.path.includes("/product/view/");
  },
  methods: {
    async downloadAll() {
      var urls = this.documents.map(function(doc) {
        return doc.url;
      });
      const zip = new JSZip();
      let count = 0;
      const zipFilename = this.product
        ? `${this.product.name}.zip`
        : `${this.newsFeedData.title}.zip`;
      urls.forEach(async function(url) {
        const urlArr = url.split("/");
        const filename = urlArr[urlArr.length - 1];
        try {
          const file = await JSZipUtils.getBinaryContent(url);

          zip.file(filename, file, { binary: true });
          count++;
          if (count === urls.length) {
            zip.generateAsync({ type: "blob" }).then(function(content) {
              saveAs(content, zipFilename);
            });
          }
        } catch (err) {
          console.log(err);
        }
      });
      this.dialog2 = false;
      this.$store.dispatch("user/setSnack", "Documents are downloading!");
      this.$store.dispatch("user/setType", "info");
    }
  }
};
</script>

<style scoped lang="scss">
.download-all:hover {
  color: #fcae00 !important;
}
.general-title:hover {
  cursor: pointer;
  color: #fcae00 !important;
  .v-icon {
    color: #fcae00 !important;
  }
}
</style>
